import { getCertificateUploadUrl, confirmCertificateUpload } from '../api/apis';

export async function uploadCertificatePdf(
  docId: string,
  certificateType: string,
  pdfBlob: Blob
): Promise<{ certificate_id: string }> {
  const { upload_url, certificate_id } = await getCertificateUploadUrl(docId, certificateType);

  // PUT directly to S3 — no Authorization header, only Content-Type (presigned URL signature constraint)
  const uploadResponse = await fetch(upload_url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/pdf' },
    body: pdfBlob,
  });

  if (!uploadResponse.ok) {
    throw new Error(`S3 upload failed: ${uploadResponse.status}`);
  }

  await confirmCertificateUpload(docId, certificate_id, certificateType);

  return { certificate_id };
}
